import React from 'react';
import './LoadingSpinner.css';

/**
 * Reusable LoadingSpinner component - Centralized loading spinner for entire project
 * 
 * USAGE EXAMPLES:
 * 
 * Basic usage:
 *   <LoadingSpinner message="Loading data..." />
 * 
 * Different sizes:
 *   <LoadingSpinner message="Processing..." size="small" />
 *   <LoadingSpinner message="Loading..." size="large" />
 * 
 * No message:
 *   <LoadingSpinner message="" />
 * 
 * With custom styling:
 *   <LoadingSpinner message="Loading..." className="custom-container" />
 * 
 * @param {Object} props
 * @param {string} props.message - Loading message to display. Default: 'Loading...'
 * @param {string} props.size - Size variant: 'small' (24px), 'medium' (32px), 'large' (40px). Default: 'medium'
 * @param {string} props.className - Optional additional CSS class for the container
 */
const LoadingSpinner = ({ 
  message = 'Loading...', 
  size = 'medium',
  className = '' 
}) => {
  return (
    <div className={`loading-spinner-container ${className}`}>
      <div className={`loading-spinner loading-spinner-${size}`}></div>
      {message && <p className="loading-spinner-message">{message}</p>}
    </div>
  );
};

export default LoadingSpinner;

